import { a as _objectSpread2, c as _defineProperty, _ as _objectWithoutProperties, e as useIsNextFeatureEnabled, d as _slicedToArray, h as _toConsumableArray, u as useTheme, S as Stack, w as withTestId, B as Box } from './ProgressiveLoader-98954bba.esm.js';
export { k as BlueprintProvider, B as Box, D as DesignSystemProvider, F as Fonts, H as Heading, L as Loader, N as NextProvider, P as ProgressiveLoader, L as Spinner, S as Stack, T as ToastTarget, n as bauhausFeatures, m as motion, o as nextFeatures, e as useIsNextFeatureEnabled, i as useNextTheme, l as useNextThemeRootClassName, u as useTheme, j as useUniqueSelector } from './ProgressiveLoader-98954bba.esm.js';
import { Global, css } from '@emotion/react';
import { normalize } from 'polished';
import { forwardRef, useId, useCallback, useState, useEffect, useRef, useMemo, useReducer } from 'react';
import invariant from 'tiny-invariant';
import { extendTheme, ButtonGroup as ButtonGroup$1, useToast as useToast$1, createStandaloneToast as createStandaloneToast$1, useBoolean, useEventListener, forwardRef as forwardRef$1, useCheckbox as useCheckbox$1, VisuallyHidden, chakra, useRadioGroupContext, useRadio as useRadio$1, RadioGroup, useMultiStyleConfig, Center, visuallyHiddenStyle, HStack, useListStyles, ListIcon as ListIcon$1 } from '@chakra-ui/react';
export { AspectRatio, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Center, CloseButton, Container, Divider, Editable, EditableInput, EditablePreview, EditableTextarea, Fade, Flex, Grid, HStack, Hide, Kbd as Hotkey, Input, InputLeftAddon, InputLeftElement, InputRightAddon, InputRightElement, LinkBox, LinkOverlay, List, ListItem, MenuCommand, MenuDivider, MenuGroup, MenuIcon, MenuItem, MenuOptionGroup, OrderedList, PinInput, PinInputField, Portal, Progress, Radio, RadioGroup, ScaleFade, Show, SimpleGrid, Slide, SlideFade, Spacer, Tab, TabList, TabPanel, TabPanels, Table, Tabs, Tbody, Td, Textarea, Tfoot, Th, Thead, Tr, UnorderedList, VStack, VisuallyHidden, VisuallyHiddenInput, Wrap, calc, cssVar, forwardRef, shouldForwardProp, chakra as system, useBoolean, useClipboard, useColorMode, useConst, useControllableState, useCounter, useDimensions, useDisclosure, useEventListener, useId, useIds, useImage, useMediaQuery, useMergeRefs, useSafeLayoutEffect, useTimeout, useUnmountEffect, useUpdateEffect, visuallyHiddenStyle } from '@chakra-ui/react';
import { mapValues } from '@hover/utilities';
import 'ramda/src/has';
import warning from 'tiny-warning';
import { T as Toast, A as Alert, c as componentMessage, u as useContext, g as getToggleButtonGroupProps, a as useToggleButtonProps, C as CheckboxGroup, b as ToggleButtonGroupProvider, d as TileCheckbox } from './Accordion-646b5f82.esm.js';
export { j as Accordion, k as AccordionItem, A as Alert, B as Badge, f as Blockquote, m as Check, l as Checkbox, C as CheckboxGroup, R as Code, h as Collapse, D as Dialog, w as Drawer, F as Field, x as FilterMenu, Q as ForceMode, I as Image, t as InputGroup, y as LoadingOverlay, z as LoadingState, L as Logo, K as Menu, N as MenuButton, O as MenuItemOption, M as Message, E as Modal, P as Panel, q as PasswordInput, H as Popover, a3 as SWIPE_THRESHOLD, n as Select, G as Sheet, S as Slider, o as StepperInput, v as TabHeading, i as Tag, p as TextInput, d as TileCheckbox, r as TileRadio, T as Toast, e as Toggle, J as Tooltip, a2 as layoutPropNames, a4 as onSwipe, _ as pickThemingProps, s as renderElement, $ as splitLayoutProps, a0 as splitSystemProps, a5 as stripMotionFromVariants, a1 as systemPropNames, U as useBreakpoint, V as useBreakpointValue, W as useDisplayInternalLabel, X as useField, Y as useReducedMotionVariants, Z as useTimeoutFlag } from './Accordion-646b5f82.esm.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { motion } from 'framer-motion';
import _omit from 'ramda/src/omit';
import 'ramda/src/mapObjIndexed';
import 'ramda/src/join';
import 'ramda/src/identity';
import 'ramda/src/ifElse';
import 'ramda/src/map';
import 'ramda/src/split';
import 'ramda/src/concat';
import 'ramda/src/toLower';
import 'ramda/src/pipe';
import _pick from 'ramda/src/pick';
import { theme } from '@hover/chakra-theme';
export { variables as cssVariables, mapResponsive, reduceResponsive, theme } from '@hover/chakra-theme';
import '@hover/chakra-theme/bauhaus';
import '@hover/chakra-theme/next';
import 'ramda/src/mergeDeepLeft';
import 'ramda/src/mergeLeft';
import { B as Body, a as Button, I as Icon } from './Link-8c722d19.esm.js';
export { B as Body, a as Button, C as ColorSchemeProvider, I as Icon, b as IconButton, L as Link, M as Motion, u as useColorScheme, c as useIsMotionReduced } from './Link-8c722d19.esm.js';
export { useSize, useSizes } from '@chakra-ui/react-use-size';
import { callAll } from '@chakra-ui/shared-utils';
export { transition } from '@hover/chakra-theme/foundation';
export { createContext } from '@chakra-ui/react-utils';
export { RemoveScroll } from 'react-remove-scroll';
export { FocusLock } from '@chakra-ui/focus-lock';
import '@hover/tokens-typography';
import '@hover/tokens-typography/next';
import '@hover/chakra-theme/components';
import '@hover/icons';
import '@hover/icons/constants';

/**
 * Apply Framer Motion variants to a component using `AnimatePresence`
 *
 * @example
 * ```tsx
 * <motion.div
 *   {...presenceVariants({
 *     animate: { opacity: 1 },
 *     exit: { opacity: 0 },
 *     initial: { opacity: 0 l
 *   })}
 * />;
 * ```
 *
 * @see {@link https://www.framer.com/api/motion/animate-presence/}
 *
 * @param variants
 * @param child whether this component is a child of a component with
 * `presenceVariants` applied (in which case, only the `variants` should be
 * applied and not the variant labels since those should propagate from the
 * parent in that case)
 *
 * @returns motion props to be spread into a component
 */
var presenceVariants = function presenceVariants(variants) {
  var child = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return _objectSpread2({
    variants: variants
  }, child ? {} : {
    animate: 'animate',
    exit: 'exit',
    initial: 'initial'
  });
};

/**
 * Apply styles to an element that's being animated on unmount using Framer
 * Motion's `AnimatePresence`. Top-level styles are automatically appended
 * with `!important` to override styles Framer applies with `popLayout`.
 *
 * @see {@link https://www.framer.com/api/motion/animate-presence/}
 *
 * @param styles system style object to apply to exiting element
 *
 * @returns styles to be applied to parent element of presence animation
 */
var presenceExitStyles = function presenceExitStyles(selector, styles) {
  return _defineProperty({}, "& ".concat(selector, ":first-of-type:not(").concat(selector, ":last-of-type)"), _objectSpread2({}, mapValues(styles, function (v) {
    return typeof v === 'string' || typeof v === 'number' ? "".concat(v, " !important") : v;
  })));
};

/**
 * Fade an element wrapped in `AnimatePresence` in and out with `opacity`
 *
 * @example
 * ```tsx
 * <motion.div {...fadePresence} />;
 * ```
 *
 * @returns motion props to be spread into a component
 */
var presenceFade = /*#__PURE__*/presenceVariants({
  animate: {
    opacity: 1
  },
  exit: {
    opacity: 0
  },
  initial: {
    opacity: 0
  }
});

/**
 * Apply custom theme overrides to the default Blueprint theme
 *
 * @param overrides theme additions and/or customizations
 * @returns
 */
var applyThemeOverrides = function applyThemeOverrides(overrides) {
  return extendTheme(overrides, theme);
};

var ButtonGroup = ButtonGroup$1;

var MotionBody = /*#__PURE__*/motion(Body);
var AnimatedToastMessage = /*#__PURE__*/forwardRef(function (props, ref) {
  return jsx(MotionBody, _objectSpread2(_objectSpread2({
    animate: {
      opacity: 1,
      y: '0%'
    },
    color: "inherit",
    exit: {
      opacity: 0,
      y: '-75%'
    },
    initial: {
      opacity: 0,
      y: '75%'
    },
    m: 0,
    textStyle: "body500",
    width: "100%"
  }, props), {}, {
    ref: ref
  }));
});

var _excluded$a = ["helpers", "props"],
  _excluded2$4 = ["dismissText"],
  _excluded3 = ["props"],
  _excluded4 = ["props"];
var mapOptionsToProps = function mapOptionsToProps(props, options) {
  switch (options === null || options === void 0 ? void 0 : options.status) {
    case 'error':
      return _objectSpread2(_objectSpread2({}, props), {}, {
        isError: true
      });
    case 'loading':
      return _objectSpread2(_objectSpread2({}, props), {}, {
        isLoading: true
      });
    default:
      return props;
  }
};

/**
 * Bauhaus toast hook
 *
 * this is intended to be used with the next (bauhaus) theme. this exists to
 * maintain backwards compatibility with anyone who may be using the standard
 * useToast, but is not yet on the next theme.
 *
 * @todo once we've migrated to the Bauhaus theme, this hook should replace
 * `useToast` entirely.
 *
 * @returns a `toast()` function that works the same way as the system toast,
 * but also provides convenience methods for removing or updating the initially
 * spawned toast instead of having to manually do so with the toast ID
 *
 */
var useBauhausToast = function useBauhausToast(toastOptions) {
  var _ref = toastOptions !== null && toastOptions !== void 0 ? toastOptions : {},
    helpers = _ref.helpers,
    defaultProps = _ref.props,
    defaultOptions = _objectWithoutProperties(_ref, _excluded$a);
  var key = useId();
  var systemToast = useToast$1(_objectSpread2({
    position: 'top-right'
  }, defaultOptions));
  var renderWithProps = useCallback(function (props) {
    return function render(_ref2) {
      var description = _ref2.description,
        callback = _ref2.onClose;
      var _props$dismissText = props.dismissText,
        dismissText = _props$dismissText === void 0 ? 'Dismiss' : _props$dismissText,
        rest = _objectWithoutProperties(props, _excluded2$4);
      return jsx(Toast, _objectSpread2({
        action: {
          callback: callback,
          label: dismissText
        },
        message: description,
        width: "100%"
      }, rest), key);
    };
  }, [key]);
  var toast = useCallback(function () {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      props = _ref3.props,
      options = _objectWithoutProperties(_ref3, _excluded3);
    var id = systemToast(_objectSpread2({
      render: renderWithProps(_objectSpread2(_objectSpread2({}, defaultProps), mapOptionsToProps(props, options)))
    }, options));
    if (!helpers) return id;
    var update = function update(_ref4) {
      var updatedProps = _ref4.props,
        updatedOptions = _objectWithoutProperties(_ref4, _excluded4);
      systemToast.update(id, _objectSpread2(_objectSpread2({
        render: renderWithProps(_objectSpread2(_objectSpread2(_objectSpread2({}, defaultProps), mapOptionsToProps(props, options)), updatedProps))
      }, options), updatedOptions));
    };
    var close = function close() {
      return systemToast.close(id);
    };
    return {
      close: close,
      id: id,
      update: update
    };
  }, [defaultProps, helpers, renderWithProps, systemToast]);
  return Object.assign(toast, systemToast);
};

var _excluded$9 = ["isClosable", "description"],
  _excluded2$3 = ["helpers"];
var omitIcon = /*#__PURE__*/_omit(['icon']);
var omitVariant = /*#__PURE__*/_omit(['variant']);

/**
 * Translate toast options into `Alert` props.
 *
 * @todo when we move over to `isClosable` for `Alert`, we can stop translating
 * that option
 *
 * @param options toast options
 * @returns `Alert` component props
 */
var translateOptions = function translateOptions() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    isClosable = _ref.isClosable,
    description = _ref.description,
    options = _objectWithoutProperties(_ref, _excluded$9);
  return _objectSpread2({
    showClose: isClosable,
    children: description
  }, _pick(['icon', 'status', 'title', 'variant', 'size'], options));
};
var wrap = function wrap(toast, helpers, defaultOptions) {
  // eslint-disable-next-line @typescript-eslint/unbound-method
  var isActive = toast.isActive,
    closeAll = toast.closeAll,
    close = toast.close,
    update = toast.update,
    promise = toast.promise;
  var getRender = function getRender(options) {
    return function (_ref2) {
      var onClose = _ref2.onClose;
      return jsx(Alert, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
        testId: "toast-alert",
        variant: "toast"
      }, translateOptions(defaultOptions)), translateOptions(options)), omitVariant(defaultOptions === null || defaultOptions === void 0 ? void 0 : defaultOptions.props)), omitVariant(options === null || options === void 0 ? void 0 : options.props)), {}, {
        onCloseClick: onClose
      }));
    };
  };
  var wrapped = Object.assign(function (options) {
    var id = toast(_objectSpread2(_objectSpread2({}, omitIcon(options)), {}, {
      render: getRender(options)
    }));
    if (!helpers) return id;
    return {
      id: id,
      update: function update(updatedOptions) {
        return toast.update(id, {
          render: getRender(updatedOptions)
        });
      },
      close: function close() {
        return toast.close(id);
      }
    };
  }, {
    isActive: isActive,
    closeAll: closeAll,
    close: close,
    promise: promise,
    update: function (_update) {
      function update(_x, _x2) {
        return _update.apply(this, arguments);
      }
      update.toString = function () {
        return _update.toString();
      };
      return update;
    }(function (id, options) {
      return update(id, _objectSpread2({
        render: getRender(options)
      }, omitIcon(options)));
    })
  });
  return wrapped;
};
var createStandaloneToast = function createStandaloneToast(standaloneOptions) {
  var _createChakraStandalo = createStandaloneToast$1(_objectSpread2({
      theme: theme
    }, standaloneOptions)),
    ToastContainer = _createChakraStandalo.ToastContainer,
    chakraToast = _createChakraStandalo.toast;
  return {
    ToastContainer: ToastContainer,
    toast: wrap(chakraToast, false, standaloneOptions === null || standaloneOptions === void 0 ? void 0 : standaloneOptions.defaultOptions)
  };
};

/**
 * A hook for displaying ephemeral notifications. This hooks wraps Chakra's
 * toast functionality and provides a render function to render toasts in line
 * with our design system.
 *
 * @remarks this hook currently renders a different component depending on the
 * theme provider that it's rendered in
 *
 * @param hookOptions default options for the toasts spawned by this hook. Pass
 * `helpers: true` to have the returned `toast` function provider an API for
 * updating and closing toasts without managing toast IDs.
 *
 * @returns a toast function for displaying toasts that returns either a toast
 * ID or an object with the toast ID and an `update` and `close` function when
 * `helpers: true` is passed to `useToast`
 */
var useToast = function useToast(hookOptions) {
  var _helpers$hookOptions = _objectSpread2({
      helpers: false
    }, hookOptions),
    helpers = _helpers$hookOptions.helpers,
    options = _objectWithoutProperties(_helpers$hookOptions, _excluded2$3);
  var chakraToast = useToast$1(omitIcon(options));
  var bauhausToast = useBauhausToast(omitIcon(hookOptions));
  var isNext = useIsNextFeatureEnabled('components');
  if (isNext) return bauhausToast;
  return wrap(chakraToast, helpers, hookOptions);
};
/**
 * Hook for displaying toasts with a custom render function
 */
var useCustomToast = useToast$1;

var useIsInitialRender = function useIsInitialRender() {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isInitialRender = _useState2[0],
    setIsInitialRender = _useState2[1];
  useEffect(function () {
    return setIsInitialRender(false);
  }, []);
  return isInitialRender;
};

var useLatestCallback = function useLatestCallback(callback) {
  var dependencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var ref = useRef(callback);
  useEffect(function () {
    ref.current = callback;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callback].concat(_toConsumableArray(dependencies)));

  // Provides a stable function every render
  return useCallback(function () {
    return ref.current.apply(ref, arguments);
  }, []);
};

var defaultOptions = {
  zoom: 0.1,
  maxZoom: false,
  initialZoom: 1,
  initialX: 0.5,
  initialY: 0.5
};
var getScrollDirection = function getScrollDirection(event) {
  // Determine the scrolling direction based on the deltaY value
  var scrollDirection = Math.sign(event.deltaY);

  // Adjust the scroll direction based on macOS natural scrolling
  var isNaturalScrolling = /Macintosh|MacIntel/.test(navigator.platform) && event.deltaMode === WheelEvent.DOM_DELTA_PIXEL;
  return isNaturalScrolling ? scrollDirection * -1 : scrollDirection;
};
var setSrcToBackground = function setSrcToBackground(image, ref) {
  /* eslint-disable no-param-reassign */
  image.style.backgroundRepeat = 'no-repeat';
  image.style.backgroundImage = "url(\"".concat(image.src, "\")");
  ref.current = "data:image/svg+xml;base64,".concat(window.btoa("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"".concat(image.naturalWidth, "\" height=\"").concat(image.naturalHeight, "\"></svg>")));
  image.src = ref.current;
  /* eslint-enable no-param-reassign */
};
var hasActualDimensions = function hasActualDimensions(_ref) {
  var actualWidth = _ref.actualWidth,
    actualHeight = _ref.actualHeight;
  return actualWidth > 0 && actualHeight > 0;
};
var getIsZoomed = function getIsZoomed(_ref2) {
  var actualHeight = _ref2.actualHeight,
    actualWidth = _ref2.actualWidth,
    zoomHeight = _ref2.zoomHeight,
    zoomWidth = _ref2.zoomWidth;
  return zoomWidth > actualWidth || zoomHeight > actualHeight;
};
var getZoomRatio = function getZoomRatio(state) {
  return hasActualDimensions(state) ? state.zoomWidth / state.actualWidth : 1.0;
};
/**
 * Calculates a new zoom state for a target zoomRatio with focal point (x,y)
 *
 * @param state Current zoom state
 * @param zoomRatio Target zoom ratio
 * @param maxZoom Max zoom
 * @param x Focal point x coordinate of the actual width (value should be
 *  between 0 and actualWidth)
 * @param y Focal point y coordinate of the actual height (value should be
 *  between 0 and actualHeight)
 */
var calculateZoom = function calculateZoom(_ref3) {
  var state = _ref3.state,
    zoomRatio = _ref3.zoomRatio,
    maxZoom = _ref3.maxZoom,
    x = _ref3.x,
    y = _ref3.y;
  var offsetX = state.offsetX,
    offsetY = state.offsetY,
    zoomWidth = state.zoomWidth,
    zoomHeight = state.zoomHeight,
    actualHeight = state.actualHeight,
    actualWidth = state.actualWidth;
  var cursorBackgroundOffsetX = x - offsetX;
  var cursorBackgroundOffsetY = y - offsetY;

  // Use the previous offset to get the percent offset between the bg edge and cursor:
  var ratioX = cursorBackgroundOffsetX / zoomWidth;
  var ratioY = cursorBackgroundOffsetY / zoomHeight;
  var newWidth = actualWidth * zoomRatio;
  var newHeight = actualHeight * zoomRatio;
  var constrainedWidth = Math.min(maxZoom * actualWidth, Math.max(newWidth, actualWidth));
  var constrainedHeight = Math.min(maxZoom * actualHeight, Math.max(newHeight, actualHeight));

  // Take the percent offset and apply it to the new size:
  var newX = x - constrainedWidth * ratioX;
  var newY = y - constrainedHeight * ratioY;
  var constrainedX = Math.max(actualWidth - constrainedWidth, Math.min(0, newX));
  var constrainedY = Math.max(actualHeight - constrainedHeight, Math.min(0, newY));
  return _objectSpread2(_objectSpread2({}, state), {}, {
    zoomWidth: constrainedWidth,
    zoomHeight: constrainedHeight,
    offsetX: constrainedX,
    offsetY: constrainedY
  });
};

/**
 * Calculates a new zoom state with the bounding box focused. A focused bounding
 * box zooms in as much as possible while keeping the entire bounding box
 * visible and centers the bounding box both vertically and horizontally
 *
 * @param state Current Zoom State
 * @param maxZoom Max Zoom
 * @param naturalBoundingBox The bounding box using the natural image coordinates
 */
var calculateFocusBox = function calculateFocusBox(_ref4) {
  var state = _ref4.state,
    maxZoom = _ref4.maxZoom,
    naturalBoundingBox = _ref4.naturalBoundingBox;
  var actualWidth = state.actualWidth,
    actualHeight = state.actualHeight,
    naturalWidth = state.naturalWidth,
    naturalHeight = state.naturalHeight;

  // Convert natural bounding box to actual bounding box
  var widthRatio = actualWidth / naturalWidth;
  var heightRatio = actualHeight / naturalHeight;
  var x = naturalBoundingBox.x * widthRatio;
  var y = naturalBoundingBox.y * heightRatio;
  var width = naturalBoundingBox.width * widthRatio;
  var height = naturalBoundingBox.height * heightRatio;

  // Calculate the maximum zoomRation that keeps the bounding box dimensions
  // from exceeding our actual dimensions
  var maxWidthZoomRatio = actualWidth / width;
  var maxHeightZoomRatio = actualHeight / height;
  var zoomRatio = Math.min(maxZoom, maxWidthZoomRatio, maxHeightZoomRatio);

  // Calculate our zoomWidth and zoomedHeight, these are constrained since we've
  // already constrained our zoomRatio to not exceed maxZoom
  var constrainedWidth = actualWidth * zoomRatio;
  var constrainedHeight = actualHeight * zoomRatio;

  // Find the center point of the bounding box in actual coordinates
  var centerX = x + width / 2;
  var centerY = y + height / 2;
  // Find the center point of the bounding box in zoomed coordinates
  var zoomedCenterX = centerX * zoomRatio;
  var zoomedCenterY = centerY * zoomRatio;

  // Offset is calculated by subtracting half the actual width from the zoomed
  // center point
  var newX = -1 * (zoomedCenterX - actualWidth / 2);
  var newY = -1 * (zoomedCenterY - actualHeight / 2);
  var constrainedX = Math.max(actualWidth - constrainedWidth, Math.min(0, newX));
  var constrainedY = Math.max(actualHeight - constrainedHeight, Math.min(0, newY));
  return _objectSpread2(_objectSpread2({}, state), {}, {
    zoomWidth: constrainedWidth,
    zoomHeight: constrainedHeight,
    offsetX: constrainedX,
    offsetY: constrainedY
  });
};
var reducer = function reducer(_ref5) {
  var zoom = _ref5.zoom,
    maxZoom = _ref5.maxZoom;
  return function (state, action) {
    switch (action.type) {
      case 'focus':
        {
          var _action$maxZoom;
          return calculateFocusBox({
            state: state,
            maxZoom: Math.min((_action$maxZoom = action.maxZoom) !== null && _action$maxZoom !== void 0 ? _action$maxZoom : Infinity, maxZoom),
            naturalBoundingBox: action.naturalBoundingBox
          });
        }
      case 'zoom':
        {
          var _action$x, _action$y;
          var actualHeight = state.actualHeight,
            actualWidth = state.actualWidth;

          // If no x, y coordinate is provided, assume the zoom focal point is centered
          var x = (_action$x = action.x) !== null && _action$x !== void 0 ? _action$x : actualWidth * 0.5;
          var y = (_action$y = action.y) !== null && _action$y !== void 0 ? _action$y : actualHeight * 0.5;
          return calculateZoom({
            state: state,
            zoomRatio: action.zoom,
            maxZoom: maxZoom,
            x: x,
            y: y
          });
        }
      case 'wheel':
        {
          var _x = action.x,
            _y = action.y,
            direction = action.direction;
          var zoomRatio = getZoomRatio(state);
          if (direction < 0) {
            zoomRatio += zoom;
          } else {
            zoomRatio -= zoom;
          }
          return calculateZoom({
            state: state,
            zoomRatio: zoomRatio,
            maxZoom: maxZoom,
            x: _x,
            y: _y
          });
        }
      case 'load':
        {
          return _objectSpread2(_objectSpread2({}, state), action.state);
        }
      case 'resize':
        {
          var width = action.width,
            height = action.height;
          return _objectSpread2(_objectSpread2({}, state), {}, {
            actualWidth: width,
            actualHeight: height,
            zoomWidth: width,
            zoomHeight: height,
            offsetX: 0,
            offsetY: 0
          });
        }
      case 'drag':
        {
          if (!getIsZoomed(state)) return state;
          var deltaX = action.deltaX,
            deltaY = action.deltaY;
          var _actualHeight = state.actualHeight,
            _actualWidth = state.actualWidth,
            zoomWidth = state.zoomWidth,
            zoomHeight = state.zoomHeight;
          var newX = state.offsetX + deltaX;
          var newY = state.offsetY + deltaY;
          var offsetX = Math.max(_actualWidth - zoomWidth, Math.min(0, newX));
          var offsetY = Math.max(_actualHeight - zoomHeight, Math.min(0, newY));
          return _objectSpread2(_objectSpread2({}, state), {}, {
            offsetX: offsetX,
            offsetY: offsetY
          });
        }
      default:
        return state;
    }
  };
};

/**
 * A hook for applying scroll/mouse wheel based zoom functionality to an image.
 * This is a React version of the `wheelzoom` library on npm, so all credit for
 * the technique used here goes to https://github.com/jackmoore.
 *
 * @see {@link https://github.com/jackmoore/wheelzoom/blob/master/wheelzoom.js}
 *
 * @example
 * ```tsx
 * const MyImage = () => {
 *   const zoom = useZoom({ zoom: 0.05, maxZoom: 5 });
 *   return <img src="..." {...zoom} />;
 * }
 * ```
 *
 * @param options zoom options
 */
var useZoom = function useZoom(options) {
  var settings = useMemo(function () {
    return _objectSpread2(_objectSpread2({}, defaultOptions), options);
  }, [options]);
  var transparentSpaceFillerRef = useRef(null);
  var maxZoom = settings.maxZoom || Infinity;
  var _useReducer = useReducer(reducer(_objectSpread2(_objectSpread2({}, settings), {}, {
      maxZoom: maxZoom
    })), {
      actualWidth: 0,
      actualHeight: 0,
      naturalWidth: 0,
      naturalHeight: 0,
      zoomWidth: 0,
      zoomHeight: 0,
      offsetX: settings.initialX,
      offsetY: settings.initialY
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var internalRef = useRef(null);
  var ref = useCallback(function (element) {
    // NOTE: this is to handle an edge case when the `ref` returned from
    // `useZoom` is passed to an image that is swapped in a carousel using `key`
    // to control how React unmounts the previous image. In that case the image
    // being unmounted sets the ref to `null` which breaks resize functionality
    // for the newly mounted incoming image.
    if (!element) return;
    internalRef.current = element;
  }, []);
  var initialize = useCallback(function (image) {
    var initial = Math.max(settings.initialZoom, 1);

    // If initialize is called more than once, checking the image src will prevent initializing twice
    if (image.src === transparentSpaceFillerRef.current) {
      return;
    }

    // Prevent wheel events over the image from scrolling the page (we can't
    // do this in the `onWheel` handler because React handlers for wheel
    // events are passive by default)
    image.addEventListener('wheel', function (e) {
      return e.preventDefault();
    }, {
      passive: false
    });
    var computedStyle = window.getComputedStyle(image, null);
    var actualWidth = parseInt(computedStyle.width, 10);
    var actualHeight = parseInt(computedStyle.height, 10);
    var zoomWidth = actualWidth * initial;
    var zoomHeight = actualHeight * initial;
    dispatch({
      type: 'load',
      state: {
        actualWidth: actualWidth,
        actualHeight: actualHeight,
        naturalWidth: image.naturalWidth,
        naturalHeight: image.naturalHeight,
        zoomWidth: zoomWidth,
        zoomHeight: zoomHeight,
        offsetX: -(zoomWidth - actualWidth) * settings.initialX,
        offsetY: -(zoomHeight - actualHeight) * settings.initialY
      }
    });
    setSrcToBackground(image, transparentSpaceFillerRef);
  }, [settings.initialX, settings.initialY, settings.initialZoom]);
  useEffect(function () {
    var _internalRef$current;
    // When SSR is enabled, it is possible for the onLoad DOM event to fire before React has completed hydration. If the
    // image is already loaded on first render, initialize immediately
    if ((_internalRef$current = internalRef.current) !== null && _internalRef$current !== void 0 && _internalRef$current.complete) {
      initialize(internalRef.current);
    }
    // This effect is intentionally only run once
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var onLoad = useCallback(function (event) {
    return initialize(event.currentTarget);
  }, [initialize]);
  var onWheel = useCallback(function (event) {
    if (!internalRef.current) return;

    // NOTE: we're not using `clientX` and `clientY` from the mouse event in
    // case the event originates from a child element of the element we're
    // capturing scroll events from (in which case we'd get coordinates
    // relative to the wrong container)
    var rect = internalRef.current.getBoundingClientRect();
    var x = event.pageX - rect.left - window.pageXOffset;
    var y = event.pageY - rect.top - window.pageYOffset;
    if (x < 0 || y < 0 || x > rect.width || y > rect.height) return;
    dispatch({
      type: 'wheel',
      x: x,
      y: y,
      direction: getScrollDirection(event)
    });
  }, []);
  var resize = useCallback(function () {
    if (!internalRef.current) return;
    var _internalRef$current$ = internalRef.current.getBoundingClientRect(),
      width = _internalRef$current$.width,
      height = _internalRef$current$.height;
    dispatch({
      type: 'resize',
      width: width,
      height: height
    });
  }, []);
  var setZoom = useCallback(function (zoom, zoomOptions) {
    dispatch(_objectSpread2({
      type: 'zoom',
      zoom: zoom
    }, zoomOptions));
  }, []);
  var focusBox = useCallback(function (naturalBoundingBox, focusBoxOptions) {
    dispatch(_objectSpread2({
      type: 'focus',
      naturalBoundingBox: naturalBoundingBox
    }, focusBoxOptions));
  }, []);
  var _useBoolean = useBoolean(false),
    _useBoolean2 = _slicedToArray(_useBoolean, 2),
    isMouseDown = _useBoolean2[0],
    _useBoolean2$ = _useBoolean2[1],
    mouseDown = _useBoolean2$.on,
    mouseUp = _useBoolean2$.off;
  var dragEventRef = useRef(null);
  var onMouseDown = useCallback(function (event) {
    event.preventDefault();
    dragEventRef.current = event.nativeEvent;
    mouseDown();
  }, [mouseDown]);
  useEventListener('mouseup', mouseUp);
  useEventListener('mousemove', function (event) {
    if (!dragEventRef.current || !isMouseDown) return;
    var clientX = event.clientX,
      clientY = event.clientY;
    var _dragEventRef$current = dragEventRef.current,
      previousX = _dragEventRef$current.clientX,
      previousY = _dragEventRef$current.clientY;
    dragEventRef.current = event;
    dispatch({
      type: 'drag',
      deltaX: clientX - previousX,
      deltaY: clientY - previousY
    });
  });
  var zoomWidth = state.zoomWidth,
    zoomHeight = state.zoomHeight,
    offsetX = state.offsetX,
    offsetY = state.offsetY;
  return {
    props: {
      ref: ref,
      onLoad: onLoad,
      onWheel: onWheel,
      onMouseDown: onMouseDown,
      style: {
        backgroundSize: "".concat(zoomWidth, "px ").concat(zoomHeight, "px"),
        backgroundPosition: "".concat(offsetX, "px ").concat(offsetY, "px")
      }
    },
    focusBox: focusBox,
    resize: resize,
    isZoomed: getIsZoomed(state),
    setZoom: setZoom,
    state: {
      zoomRatio: getZoomRatio(state)
    }
  };
};

var Styles = function Styles(_ref) {
  var _ref$colors = _ref.colors,
    colors = _ref$colors === void 0 ? true : _ref$colors,
    _ref$fonts = _ref.fonts,
    fonts = _ref$fonts === void 0 ? true : _ref$fonts,
    _ref$normalize = _ref.normalize,
    normalize$1 = _ref$normalize === void 0 ? true : _ref$normalize;
  var theme = useTheme();
  var themeColors = theme.colors,
    themeFonts = theme.fonts;
  !(themeColors && themeFonts) ? process.env.NODE_ENV !== "production" ? invariant(false, componentMessage('Styles', 'unable to access theme, did you forget a `<BlueprintProvider />`?')) : invariant(false) : void 0;
  var getColors = function getColors() {
    return /*#__PURE__*/css("body{background-color:", themeColors.background, ";color:", themeColors.foreground, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:getColors;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
  };
  var getFonts = function getFonts() {
    return /*#__PURE__*/css("body{font-family:", themeFonts.body, ";}h1,h2,h3,h4,h5,h6{font-family:", themeFonts.heading, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:getFonts;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
  };
  return jsx(Global, {
    styles: /*#__PURE__*/css(colors ? getColors() : '', " ", fonts ? getFonts() : '', " ", normalize$1 ? normalize() : '', ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Styles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
};

var _excluded$8 = ["children"],
  _excluded2$2 = ["children", "isMinimal"];
var CheckButton = /*#__PURE__*/forwardRef$1(function (_ref, ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$8);
  var value = props.value;
  var group = useContext();
  var _useCheckbox = useCheckbox$1(getToggleButtonGroupProps({
      group: group,
      props: props,
      isChecked: (group === null || group === void 0 ? void 0 : group.value) != null && value != null ? group.value.includes(value) : props.isChecked
    })),
    getCheckboxProps = _useCheckbox.getCheckboxProps,
    getInputProps = _useCheckbox.getInputProps,
    getLabelProps = _useCheckbox.getLabelProps,
    htmlProps = _useCheckbox.htmlProps,
    isChecked = _useCheckbox.state.isChecked;
  return jsxs(Button, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
    as: "label",
    className: "hover--check-button"
  }, htmlProps), getLabelProps()), getCheckboxProps()), useToggleButtonProps({
    props: props,
    group: group,
    isChecked: isChecked
  })), {}, {
    // Since we're applying both `getLabelProps` and `getCheckboxProps` to
    // the root button as `label` element, we need to override the
    // `aria-hidden` value Chakra sets in `getCheckboxProps` (in a more
    // standard checkbox it gets applied to the visual control which is
    // adjacent to the `label` instead of wrapping everything)
    "aria-hidden": false,
    "data-checkbox": "",
    children: [jsx(VisuallyHidden, {
      children: jsx(chakra.input, _objectSpread2(_objectSpread2({}, getInputProps()), {}, {
        ref: ref
      }))
    }), children]
  }));
});
var CheckButtonGroup = function CheckButtonGroup(_ref2) {
  var children = _ref2.children,
    isMinimal = _ref2.isMinimal,
    props = _objectWithoutProperties(_ref2, _excluded2$2);
  return (
    // @ts-ignore
    jsx(CheckboxGroup, _objectSpread2(_objectSpread2({}, props), {}, {
      children: jsx(ToggleButtonGroupProvider, {
        value: {
          isMinimal: isMinimal
        },
        children: children
      })
    }))
  );
};

var _excluded$7 = ["children"],
  _excluded2$1 = ["children", "isMinimal"];
var RadioButton = /*#__PURE__*/forwardRef$1(function (_ref, ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$7);
  var value = props.value;
  var group = useRadioGroupContext();
  var _useRadio = useRadio$1(getToggleButtonGroupProps({
      group: group,
      props: props,
      isChecked: (group === null || group === void 0 ? void 0 : group.value) != null && value != null ? group.value === value : props.isChecked
    })),
    getCheckboxProps = _useRadio.getCheckboxProps,
    getInputProps = _useRadio.getInputProps,
    getLabelProps = _useRadio.getLabelProps,
    htmlProps = _useRadio.htmlProps,
    isChecked = _useRadio.state.isChecked;
  return jsxs(Button, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
    as: "label",
    className: "hover--radio-button"
  }, htmlProps), getLabelProps()), getCheckboxProps()), useToggleButtonProps({
    group: group,
    props: props,
    isChecked: isChecked
  })), {}, {
    // Since we're applying both `getLabelProps` and `getCheckboxProps` to
    // the root button as `label` element, we need to override the
    // `aria-hidden` value Chakra sets in `getCheckboxProps` (in a more
    // standard checkbox it gets applied to the visual control which is
    // adjacent to the `label` instead of wrapping everything)
    "aria-hidden": false,
    "data-radio": "",
    children: [jsx(VisuallyHidden, {
      children: jsx(chakra.input, _objectSpread2(_objectSpread2({}, getInputProps()), {}, {
        ref: ref
      }))
    }), children]
  }));
});
var RadioButtonGroup = /*#__PURE__*/forwardRef$1(function (_ref2, ref) {
  var children = _ref2.children,
    isMinimal = _ref2.isMinimal,
    props = _objectWithoutProperties(_ref2, _excluded2$1);
  return jsx(RadioGroup, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    children: jsx(ToggleButtonGroupProvider, {
      value: {
        isMinimal: isMinimal
      },
      children: children
    })
  }));
});

var _excluded$6 = ["name", "isDisabled", "onChange"];

/**
 * Hook for implementing a custom checkbox button that also reads from `CheckboxGroup`
 * context. This composes Chakra's `useCheckbox` hook so it functions the same way
 * but automatically wires up its selection state from the `CheckboxGroup` context
 * if available.
 *
 * @see {@link https://chakra-ui.com/docs/hooks/use-checkbox}
 *
 * @param props checkbox props
 */
var useCheckbox = function useCheckbox(_ref) {
  _ref.name;
    var isDisabled = _ref.isDisabled,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded$6);
  var group = useContext();
  var value = props.value;
  return useCheckbox$1(_objectSpread2(_objectSpread2({}, props), {}, {
    isChecked: (group === null || group === void 0 ? void 0 : group.value) != null && value != null ? group.value.includes(value) : props.isChecked,
    isDisabled: (group === null || group === void 0 ? void 0 : group.isDisabled) || isDisabled,
    onChange: group !== null && group !== void 0 && group.onChange && props.value != null ? callAll(group.onChange, onChange) : onChange
  }));
};

var _excluded$5 = ["radioProps", "inputProps", "colorScheme", "size", "variant"];
/**
 * Radio control component intended to be used to render the radio selection
 * control within a custom radio component implemented with `useRadio`
 */
var RadioControl = /*#__PURE__*/forwardRef$1(function (_ref, ref) {
  var radioProps = _ref.radioProps,
    inputProps = _ref.inputProps,
    colorScheme = _ref.colorScheme,
    size = _ref.size,
    variant = _ref.variant,
    props = _objectWithoutProperties(_ref, _excluded$5);
  var styles = useMultiStyleConfig('Radio', {
    colorScheme: colorScheme,
    size: size,
    variant: variant
  });
  return jsxs(Center, _objectSpread2(_objectSpread2({}, props), {}, {
    __css: styles.container,
    children: [jsx(chakra.input, _objectSpread2(_objectSpread2({
      className: "hover-radio-control__input"
    }, inputProps), {}, {
      ref: ref,
      style: visuallyHiddenStyle
    })), jsx(chakra.div, _objectSpread2(_objectSpread2({
      alignItems: "center",
      className: "hover-radio-control__control",
      display: "flex",
      justifyContent: "center"
    }, radioProps), {}, {
      __css: styles.control
    }))]
  }));
});

var _excluded$4 = ["name", "isDisabled", "onChange"];

/**
 * Hook for implementing a custom radio button that also reads from `RadioGroup`
 * context. This composes Chakra's `useRadio` hook so it functions the same way
 * but automatically wires up its selection state from the `RadioGroup` context
 * if available.
 *
 * @see {@link https://chakra-ui.com/docs/hooks/use-radio}
 *
 * @param props radio props
 */
var useRadio = function useRadio(_ref) {
  var _group$name;
  var name = _ref.name,
    isDisabled = _ref.isDisabled,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded$4);
  var group = useRadioGroupContext();
  return useRadio$1(_objectSpread2(_objectSpread2({}, props), {}, {
    name: (_group$name = group === null || group === void 0 ? void 0 : group.name) !== null && _group$name !== void 0 ? _group$name : name,
    isChecked: (group === null || group === void 0 ? void 0 : group.value) != null && props.value != null ? group.value === props.value : props.isChecked,
    isDisabled: (group === null || group === void 0 ? void 0 : group.isDisabled) || isDisabled,
    onChange: group !== null && group !== void 0 && group.onChange && props.value != null ? callAll(group.onChange, onChange) : onChange
  }));
};

var _excluded$3 = ["children", "spacing"];
var Form = function Form(_ref) {
  var children = _ref.children,
    _ref$spacing = _ref.spacing,
    spacing = _ref$spacing === void 0 ? '' : _ref$spacing,
    props = _objectWithoutProperties(_ref, _excluded$3);
  return (
    // @ts-ignore
    jsx(Stack, _objectSpread2(_objectSpread2({
      spacing: spacing
    }, withTestId(props)), {}, {
      as: "form",
      children: children
    }))
  );
};

var _excluded$2 = ["children"],
  _excluded2 = ["box"];
var Label = /*#__PURE__*/forwardRef$1(function (_ref, ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$2);
  if ('box' in props && props.box) {
    props.box;
      var boxProps = _objectWithoutProperties(props, _excluded2);
    return jsx(Box, _objectSpread2(_objectSpread2({}, boxProps), {}, {
      as: "label",
      ref: ref,
      children: children
    }));
  }
  return jsx(Body, _objectSpread2(_objectSpread2({}, props), {}, {
    element: "label",
    ref: ref,
    children: children
  }));
});

var _excluded$1 = ["content", "flexDirection", "heading", "onClick", "selected", "subHeading"];
var BlockOption = function BlockOption(_ref) {
  var content = _ref.content,
    _ref$flexDirection = _ref.flexDirection,
    flexDirection = _ref$flexDirection === void 0 ? 'column' : _ref$flexDirection,
    heading = _ref.heading,
    onClick = _ref.onClick,
    selected = _ref.selected,
    subHeading = _ref.subHeading,
    props = _objectWithoutProperties(_ref, _excluded$1);
  var _useState = useState(selected || false),
    _useState2 = _slicedToArray(_useState, 2),
    isSelected = _useState2[0],
    setIsSelected = _useState2[1];
  var onClickBlockOption = useCallback(function () {
    setIsSelected(!isSelected);
    onClick === null || onClick === void 0 || onClick(!isSelected);
  }, [isSelected, onClick]);
  return jsx(TileCheckbox, _objectSpread2(_objectSpread2({
    description: content,
    isChecked: isSelected,
    onChange: onClickBlockOption,
    variant: flexDirection === 'row' ? 'horizontal' : 'vertical'
  }, props), {}, {
    children: jsxs(HStack, {
      justifyContent: "space-between",
      children: [jsx(Body, {
        "aria-level": 5,
        as: "span",
        fontWeight: "heading",
        role: "heading",
        children: heading
      }), flexDirection === 'column' && subHeading && jsx(Body, {
        "aria-level": 6,
        as: "span",
        color: "neutral.600",
        fontWeight: "heading",
        role: "heading",
        children: subHeading
      })]
    })
  }));
};

var _excluded = ["as", "icon", "orientation"];
// NOTE: we were originally requiring consumers to include `ListIcon` with the
// `as` prop set to `Icon` per Chakra's convention. A Chakra upgrade broke the
// icon styles that are applied to `ListIcon`, so this fixes that with the
// added bonus that we no longer require `as={Icon}` to be set manually.
var ListIcon = /*#__PURE__*/forwardRef$1(function (_ref, ref) {
  var as = _ref.as,
    icon = _ref.icon;
    _ref.orientation;
    var props = _objectWithoutProperties(_ref, _excluded);
  var styles = useListStyles();
  return jsx(ListIcon$1, _objectSpread2(_objectSpread2({
    as: as !== null && as !== void 0 ? as : Icon,
    icon: icon
  }, props), {}, {
    ref: ref,
    sx: styles.icon
  }));
});

var alpha = function alpha(value, color) {
  process.env.NODE_ENV !== "production" ? warning(false, "Directly importing the `alpha` helper is deprecated, no transparency will be applied to ".concat(color, ". Instead, use the `alpha` helper from the theme:\n\nimport { useTheme } from '@hover/blueprint';\n\nconst { colors } = useTheme();\ncolors.alpha(").concat(value, ", ").concat(color, ");\n")) : void 0;
  return color;
};

export { AnimatedToastMessage, BlockOption, ButtonGroup, CheckButton, CheckButtonGroup, Form, Label, ListIcon, RadioButton, RadioButtonGroup, RadioControl, Styles, alpha, applyThemeOverrides, createStandaloneToast, presenceExitStyles, presenceFade, presenceVariants, useCheckbox, useCustomToast, useIsInitialRender, useLatestCallback, useRadio, useToast, useZoom };
